import React from "react";

export interface IAdminDetail {
    label: React.ReactNode;
    value: React.ReactNode;
    // ocupa a linha inteira (textos longos, como descrição)
    full?: boolean;
}

// lista rótulo/valor em grade — substitui as antigas "tabelas" de faixa cinza + valor centralizado
export default function AdminDetails({ items, columns = 2, className = "" }: { items: IAdminDetail[], columns?: 1 | 2 | 3, className?: string }) {

    const grid = columns === 1 ? "" : columns === 3 ? "sm:grid-cols-2 lg:grid-cols-3" : "sm:grid-cols-2";

    return (
        <dl className={`grid grid-cols-1 gap-x-6 gap-y-4 ${grid} ${className}`}>
            {
                items.map((item, idx) => {
                    const empty = item.value === undefined || item.value === null || item.value === "";
                    return (
                        <div key={idx} className={`min-w-0 ${item.full ? "sm:col-span-full" : ""}`}>
                            <dt className="text-[11px] font-bold uppercase tracking-wider text-gray-400">{item.label}</dt>
                            <dd className={`mt-0.5 text-sm break-words whitespace-pre-line ${empty ? "text-gray-400" : "text-gray-900"}`}>{empty ? "—" : item.value}</dd>
                        </div>
                    )
                })
            }
        </dl>
    )
}
